import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { getDateProduction } from "../../../Base/Services/FechasService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Card from "../../../Base/Components/Card/Card";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import CalendarWeek from "../../../Base/Components/Form/CalendarWeek";

// ------------------- CONSULTAS A LA API---------------------------
import { getDetallesSales, getEncabezadoSales } from "../../../API/Ventas/SalesOrderRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import SalesOrdersCRUD from './SalesOrdersCRUD'
import CalendarioMensual from "../../../Base/Components/CalendarioMensual/CalendarioMensual";


const SalesOrdersScreen = () => {
    const { userAuth } = useContext(AuthContext);
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);

    const [listadoEnc, setListadoEnc] = useState([]);
    const [listadoDet, setListadoDet] = useState([]);

    const [loading, setLoading] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [showDialog, setShowDialog] = useState(false);
    const [showDialogReporte, setShowDialogReporte] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedEnc, setSelectedEnc] = useState([]);
    const [selectedDet, setSelectedDet] = useState([]);
    const [Languaje, setLanguaje] = useState("es");


    const getInfo = async () => {
        if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
            toastShow(
                toast,
                "warn",
                "Advertencia",
                "Por favor, seleccione un rango de fechas válido."
            );
            return;
        }
        setLoading(true);
        const fechas = getDateProduction(dates);

        const encabezadoTempo = await getEncabezadoSales(fechas);
        setListadoEnc(encabezadoTempo);

        const detallesTempo = await getDetallesSales(fechas);
        setListadoDet(detallesTempo);

        setLoading(false);
    };

    const LiberarOrden = async (data) => {
        confirmDialog({
            message: "¿Está seguro que desea Liberar la orden?",
            header: "Liberar",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
                setLoading(true);
                const fuente = selectedEnc?.length > 0 ? selectedEnc : data;
                const datosEnviar = fuente.map((s) => ({
                    ...s,
                    IdSalesOrder: s?.IdSalesOrder,
                    IdUserEdit: userAuth?.IdUser,
                    status: !s.liberado ? 106 : 102,
                }));

                // for (const item of datosEnviar) {
                //   await LiberarOrdenVenta(item.IdSalesOrder, item.IdUserEdit, !item?.liberado);
                // }
                toastShow(toast, "success", "Editado", "Estado cambiado correctamente");
                setTimeout(() => {
                    setLoading(false);
                    setSelectedEnc([]);
                    getInfo();
                }, 500);
            },
            reject: () => { },
        });
    };

    const EliminarOrden = async () => {
        if (activeIndex === 0) {
            let dataLiberdada = selectedEnc?.find((i) => i?.IdStatus === 106);
            let datos = selectedEnc?.filter((i) => i?.IdStatus !== 106);
            if (dataLiberdada) {
                toastShow(
                    toast,
                    "warn",
                    "Advertencia",
                    "Algunas ordenes seleccionadas no se pueden eliminar, ya estan Liberadas."
                );
            }
            if (datos?.length > 0) {
                confirmDialog({
                    message: "¿Está seguro que desea Eliminar la orden de venta?",
                    header: "Eliminar Orden",
                    icon: "pi pi-exclamation-triangle",
                    accept: async () => {
                        setLoading(true);
                        const datosEnviar = datos.map((s) => ({
                            ...s,
                            IdSalesOrder: s?.IdSalesOrder,
                            IdUserEdit: userAuth?.IdUser,
                            status: 104,
                        }));
                        // for (const item of datosEnviar) {
                        //   await EliminarOrdenVenta(item.IdSalesOrder, item.IdUserEdit, item?.status);
                        // }
                        toastShow(
                            toast,
                            "success",
                            "Eliminada",
                            "Orden de venta eliminada correctamente"
                        );
                        setLoading(false);
                        setSelectedEnc([]);
                        getInfo();
                    },
                    reject: () => { },
                });
            }
        } else if (activeIndex === 1) {
            let dataLiberdada = selectedDet?.find((i) => i?.IdStatus === 106);
            let datos = selectedDet?.filter((i) => i?.IdStatus !== 106);
            if (dataLiberdada) {
                toastShow(
                    toast,
                    "warn",
                    "Advertencia",
                    "Algunos detalles seleccionadas no se pueden eliminar, ya estan Liberados."
                );
            }
            if (datos?.length > 0) {
                confirmDialog({
                    message: "¿Está seguro que desea eliminar detalles?",
                    header: "Eliminar Detalles",
                    icon: "pi pi-exclamation-triangle",
                    accept: async () => {
                        setLoading(true);
                        const datosEnviar = datos.map((s) => ({
                            ...s,
                            IdSalesOrderDetail: s?.IdSalesOrderDetail,
                            IdUserEdit: userAuth?.IdUser,
                            status: 104,
                        }));
                        // for (const item of datosEnviar) {
                        //   await EliminarOrdenVentaDet(item.IdSalesOrderDetail, item.IdUserEdit, item?.status);
                        // }
                        toastShow(
                            toast,
                            "success",
                            "Eliminado",
                            "Detalles eliminados correctamente"
                        );
                        setLoading(false);
                        setSelectedEnc([]);
                        getInfo();
                    },
                    reject: () => { },
                });
            }
        }
    };

    const columns = [
        {
            field: "IdSalesOrder",
            header: "ID",
            headerEn: "ID",
            hidden: userAuth.IdRol === 1,
            className: "XXsmall",
            frozen: 1,
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "OrderDate",
            header: "Fecha Creación",
            headerEn: "Date Create",
            Format: "Date",
            frozen: 1,
            className: 'Xsmall',
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "SalesOrder",
            headerEn: "No. Order",
            header: "No. Orden",
            frozen: 1,
            className: "medium",
            Format: "Modal",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            header: "Estado",
            headerEn: "Status",
            field: "IdStatus",
            className: "Xsmall",
            Format: "Estado",
            body: (rowData) => ({
                ID: rowData.IdStatus,
                Estado: rowData.StatusName,
            }),
        },
        {
            field: "SalesAgent",
            header: "Agente de Ventas",
            headerEn: "Agent Name",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "CustomerServiceAgent",
            header: "Agente Servicio Cliente",
            headerEn: "Agent Service Customer",
            className: "medium",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "CustomerName",
            header: "Cliente",
            headerEn: "Customer",
            className: "Xlarge",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "CompanyName",
            header: "Buyer",
            headerEn: "Buyer",
            className: "large",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "CustomerOrder",
            header: "Orden Cliente",
            headerEn: "Customer Order",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "OrderType",
            header: "Tipo de Orden",
            headerEn: "Order Type",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "TipoPagoN",
            header: "Tipo de Pago",
            headerEn: "Payment Type",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "MaxPercent",
            header: "Porcentaje Máximo",
            headerEn: "Max Percent",
            className: "Xsmall",
            Format: "Porcentaje",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "Terms",
            header: "Término",
            headerEn: "Term",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "orderAgent",
            header: "Agente de Orden",
            headerEn: "Order Agent",
            className: "medium",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            header: "Comentario",
            headerEn: "Comment",
            field: "Comments",
            className: "XXXlarge",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrder > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            headerName: 'Cantidades',
            headerNameEn: 'Quantities',
            children: [
                {
                    field: "QtyKgs",
                    header: "Kgs",
                    headerEn: "Kgs",
                    className: "Xsmall",
                    Format: "Currency",
                    Sumary: 'sum',
                },
                {
                    field: "QtyYds",
                    header: "Yds",
                    headerEn: "Yds",
                    className: "Xsmall",
                    Format: "Currency",
                    Sumary: 'sum',
                },
                {
                    field: "QtyLbs",
                    header: "Lbs",
                    headerEn: "Lbs",
                    Sumary: 'sum',
                    className: "Xsmall",
                    Format: "Currency",
                },
            ]
        },
        {
            headerName: 'Montos',
            headerNameEn: 'Amounts',
            children: [
                {
                    field: "MontoKgs",
                    header: "Kgs",
                    headerEn: "Kgs",
                    className: "Xsmall",
                    Format: "Currency",
                    Sumary: 'sum',
                },
                {
                    field: "MontoYds",
                    header: "Yds",
                    headerEn: "Yds",
                    className: "Xsmall",
                    Format: "Currency",
                    Sumary: 'sum',
                },
                {
                    field: "MontoLbs",
                    header: "Lbs",
                    headerEn: "Lbs",
                    className: "Xsmall",
                    Sumary: 'sum',
                    Format: "Currency",
                },
            ]
        },
        // {
        //     field: "IdSalesOrder",
        //     header: "Formato",
        //     headerEn: "Format",
        //     Format: "SplitButton",
        //     filter: false,
        //     frozen: 1,
        //     alignFrozen: "right",
        //     className: "Xsmall",
        //     Botones: [
        //         {
        //             icon: "pi pi-print",
        //             tooltip: "Formato",
        //             tooltipOptions: { position: "left" },
        //             onClick: (rowData) => {
        //                 if (rowData?.IdSalesOrder > 0) {
        //                     setShowDialogReporte(true);
        //                     setSelectedEnc([rowData]);
        //                 }
        //             },
        //             items: [
        //                 {
        //                     label: "Ingles",
        //                     onClick: (rowData) => {
        //                         if (rowData?.IdSalesOrder > 0) {
        //                             setShowDialogReporte(true);
        //                             setSelectedEnc([rowData]);
        //                             setLanguaje("en");
        //                         }
        //                     },
        //                 },
        //                 {
        //                     label: "Español",
        //                     onClick: (rowData) => {
        //                         if (rowData?.IdSalesOrder > 0) {
        //                             setShowDialogReporte(true);
        //                             setSelectedEnc([rowData]);
        //                         }
        //                     },
        //                 },
        //             ],
        //         },
        //     ],
        // },
        {
            field: "IdSalesOrder",
            header: "",
            Format: "Botones",
            filter: false,
            frozen: 1,
            alignFrozen: "right",
            Botones: [
                {
                    icon: "pi pi-pencil",
                    tooltip: "Editar",
                    tooltipOptions: { position: "left" },
                    onClick: (rowData) => {
                        if (rowData?.IdSalesOrder > 0) {
                            setShowDialog(true);
                            setSelectedEnc([rowData]);
                        }
                    },
                },
            ],
        },
    ];

    const table = {
        Columns: columns,
        Data: listadoEnc,
        loading: loading,
        selected: selectedEnc,
        setSelected: setSelectedEnc,
        showModal: () => { },
    };

    const columnsDet = [
        {
            field: "IdSalesOrderDetail",
            header: "ID",
            headerEn: "ID",
            hidden: userAuth.IdRol === 1,
            className: "Xsmall",
            frozen: 1,
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "OrderDateEnc",
            header: "Fecha Creación",
            headerEn: "Date Create",
            Format: "Date",
            frozen: 1,
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "SalesOrder",
            headerEn: "No. Order",
            header: "No. Orden",
            frozen: 1,
            className: "medium",
            Format: "Modal",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            header: "Estado",
            headerEn: "Status",
            field: "IdStatus",
            className: "Xsmall",
            Format: "Estado",
            body: (rowData) => ({
                ID: rowData.IdStatus,
                Estado: rowData.StatusName,
            }),
        },
        {
            field: "Yarns",
            header: "Hilo",
            headerEn: "Yarn",
            className: "XXXXlarge",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "StyleCategory",
            header: "Categoría",
            headerEn: "Category",
            className: 'Xsmall',
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "ColorName",
            header: "Color",
            headerEn: "Color",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "FechaRequerida",
            header: "Fecha Requerida",
            headerEn: "Required Date",
            className: "medium",
            Format: "Date",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "WidthD",
            header: "WidthD",
            headerEn: "WidthD",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "IdKnittingLoss",
            header: "Knitting Loss",
            headerEn: "Knitting Loss",
            Format: 'Porcentaje',
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "IdDyingLoss",
            header: "Dying Loss",
            headerEn: "Dying Loss",
            className: "Xsmall",
            Format: 'Porcentaje',
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "IdWorkflow",
            header: "Flujo de Trabajo",
            headerEn: "Work Flow",
            className: "XXXXlarge",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "KCDescription",
            header: "Descripción",
            headerEn: "Description",
            className: "XXXlarge",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            headerName: 'Yds',
            children: [
                {
                    field: "YdsTejido",
                    header: "Tejido",
                    headerEn: "Tejido",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "YdsAcabado",
                    header: "Acabado",
                    headerEn: "Acabado",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "YdsAcabadoLoss",
                    header: "Acab. Loss",
                    headerEn: "Acab. Loss",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "YdsTejidoLoss",
                    header: "Tejido Loss",
                    headerEn: "Tejido Loss",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
            ]
        },
        {
            headerName: 'Kgs',
            children: [
                {
                    field: "KgsAcabado",
                    header: "Acabado",
                    headerEn: "Acabado",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "KgsAcabadoLoss",
                    header: "Acabado Loss",
                    headerEn: "Acabado Loss",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "KgsQtyWL",
                    header: "KgsQtyWL",
                    headerEn: "KgsQtyWL",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "KLbsQtyWL",
                    header: "KLbsQtyWL",
                    headerEn: "LbsQtyWL",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
            ]
        },

        {
            field: "GYA",
            header: "GYA",
            headerEn: "GYA",
            Format: 'Currency',
            Sumary: 'sum',
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "LabDip",
            header: "LabDip",
            headerEn: "LabDip",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "CategoriaDensidad",
            header: "Densidad",
            headerEn: "Density",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "ItemNumber",
            header: "Items",
            headerEn: "Items",
            Format: 'Currency',
            Sumary: 'sum',
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "UnitName",
            header: "Unidad",
            headerEn: "Unit",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "GeneralQty",
            header: "General Qty",
            headerEn: "General Qty",
            Format: 'Currency',
            Sumary: 'sum',
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            headerName: 'Cantidades',
            headerNameEn: 'Quantities',
            children: [
                {
                    field: "KgsQty",
                    header: "Kgs",
                    headerEn: "Kgs",
                    Format: 'Currency',
                    Sumary: 'sum',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                {
                    field: "LbsQty",
                    Sumary: 'sum',
                    header: "Lbs",
                    headerEn: "Lbs",
                    Format: 'Currency',
                    className: "Xsmall",
                    onCellDoubleClicked: ({ data }) => {
                        if (data?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([data]);
                        }
                    },
                },
                // {
                //     field: "YdsQty",
                //     header: "Yds",
                //     Sumary: 'sum',
                //     headerEn: "Yds",
                //     Format: 'Currency',
                //     className: "Xsmall",
                //     onCellDoubleClicked: ({ data }) => {
                //         if (data?.IdSalesOrderDetail > 0) {
                //             setShowDialog(true);
                //             setSelectedEnc([data]);
                //         }
                //     },
                // },
            ]
        },
        {
            field: "Subtotal",
            header: "Sub Total",
            Sumary: 'sum',
            Format: 'Currency',
            Sumaty: 'sum',
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdSalesOrderDetail > 0) {
                    setShowDialog(true);
                    setSelectedEnc([data]);
                }
            },
        },
        {
            field: "IdSalesOrderDetail",
            header: "",
            Format: "Botones",
            filter: false,
            frozen: 1,
            alignFrozen: "right",
            Botones: [
                {
                    icon: "pi pi-pencil",
                    tooltip: "Editar",
                    tooltipOptions: { position: "left" },
                    onClick: (rowData) => {
                        if (rowData?.IdSalesOrderDetail > 0) {
                            setShowDialog(true);
                            setSelectedEnc([rowData]);
                        }
                    },
                },
            ],
        },
    ];

    const tableDet = {
        Columns: columnsDet,
        Data: listadoDet,
        loading: loading,
        selected: selectedDet,
        setSelected: setSelectedDet,
        showModal: () => { },
    };

    useEffect(() => {
        getInfo();
        setTitlePage(getLabel(baseLang, "OrdenesVenta", config.language));
    }, []);

    useEffect(() => {
        setSelectedDet([]);
        setSelectedEnc([]);
    }, [activeIndex]);

    return (
        <div>
            <Toast ref={toast} />
            <Card
                titulo={
                    <div className="botones flex-wrap">
                        <h2>{getLabel(baseLang, "OrdenesVenta", config.language)}</h2>
                        <CalendarWeek
                            date={dates}
                            setDate={setDates}
                            selectionMode="range"
                        />
                        {/* <CalendarioMensual
                        getInfo={getFechasFacturasManuales}
                        data={data}
                        setData={setData}
                        dates={dates}
                        setDates={setDates}
                        selected={selected}
                        setSelected={setSelected}
                        loading={loading}
                        setLoading={setLoading}
                    /> */}
                        <Button
                            icon="pi pi-refresh"
                            tooltip="Buscar"
                            onClick={() => getInfo()}
                        />
                    </div>
                }
                contenido={
                    <div className="pt-4">
                        <TabView
                            activeIndex={activeIndex}
                            onTabChange={(e) => setActiveIndex(e.index)}
                        >
                            <TabPanel header={getLabel(baseLang, "listadoTab", config.language)} >
                                <div style={{ height: "80vh" }}>
                                    <AgGrid table={table} />
                                </div>
                            </TabPanel>

                            <TabPanel header={getLabel(baseLang, "detallesTab", config.language)} >
                                <div style={{ height: "80vh" }}>
                                    <AgGrid table={tableDet} />
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                }
            />
            
            {showDialog && (
                <SalesOrdersCRUD
                    dialogSO={showDialog}
                    hideDialog={()=>{setShowDialog(false); setSelectedEnc([]); setSelectedDet([])}}
                    IdSalesOrder={selectedEnc[0]?.IdSalesOrder || selectedDet[0]?.IdSalesOrder}
                />
            )}

            {/* {showDialogReporte && (
                <SalesOrderReporte
                    showDialogReporte={showDialogReporte}
                    setShowDialogReporte={setShowDialogReporte}
                    selectedEnc={selectedEnc}
                    getInfo={getInfo}
                    Language={Languaje}
                />
            )} */}
        </div>
    );
};

export default SalesOrdersScreen;
